export default "__VITE_ASSET__wvDJLsb4__"